module.exports = __webpack_public_path__ + "static/media/thumb.6835d5a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/hall-farm-holiday-lets/thumb.jpg
// module id = 44
// module chunks = 0